<script>
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { mapGetters } from 'vuex'
export default {
    name: 'AlertGroupOrder',
    components: { ButtonLoader },
    data() {
        return {
            loading: false,
        }
    },

    computed: {
        ...mapGetters({
            smDevice: 'smDevice',
        }),
        currency() {
            return this.$store.getters['active/currency']
        },
        cart() {
            return this.$cart
        },
        calculation() {
            return this.cart.calculation
        },
        calculated() {
            return this.cart.calculated
        },
        user() {
            return this.$user.model
        },
        group() {
            return this.calculated ? this.calculation.group_order_employees.length + 1 : 1
        },
        available() {
            if (this.calculated) {
                let available = 0
                this.calculation.group_order_employees.forEach((val) => {
                    available += this.cart.groupOrderBalances[val]
                })
                return this.$options.filters.toCurrency(
                    available + this.cart.groupOrderPersonalBudget,
                    this.currency.locale,
                    this.currency.currency_code
                )
            }
            return undefined
        },
        contribution() {
            if (this.calculated) {
                return this.$options.filters.toCurrency(
                    Object.entries(this.calculation.group_order_sum_distribution).reduce(
                        (acc, val) => (acc[1] || acc) + val[1]
                    ),
                    this.currency.locale,
                    this.currency.currency_code
                )
            }
            return undefined
        },
    },
    methods: {
        async discard() {
            try {
                this.loading = true
                await this.cart.resetGroupOrder()
                await this.cart.calculate()
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<template lang="pug">
transition(name="alert")
    .alert-wrapper(v-if="cart.isGroupOrder")
        .alert.alert-info.d-flex.flex-column.flex-lg-row.align-items-center.justify-content-center
            span.ml-auto.pl-lg-11.text-center.text-leg-left {{$t('order.group', {user: user.first_name , group: group, available: available, contributed: contribution})}}
            button-loader.btn.btn-info-light.btn-xs.ml-auto.mt-4.mt-lg-0(@click="discard" :class="{'btn-block': smDevice}" :loading="loading" inline) {{$t('base.discard')}}

</template>
